import { Component } from '@angular/core';
import { Platform,IonicPage, NavController, NavParams , MenuController} from 'ionic-angular';

import { CommonService } from '../../services/common.service';
import { AppRate } from '@ionic-native/app-rate';

/**
 * Generated class for the DashboardPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
 @IonicPage()
 @Component({
 	selector: 'page-dashboard',
 	templateUrl: 'dashboard.html',
 })
 export class DashboardPage {

 	
 	selectedDays = 'all';
 	ratingTakenBy = 'all';
 	ratingFactor=[];
 	ratingStatistics = {noOfFeedback : 0, lastRatedAt:'N/A',noOfComment:0};
 	appRateShown=false;
 	ratingCollectorList:any=[];
 	showRatingTakenBy=false;

 	constructor(public navCtrl: NavController, public navParams: NavParams, public menu: MenuController, public commonService:CommonService,public platform: Platform,private appRate: AppRate) {

 		platform.ready().then(() => { 
 			if(this.appRate.preferences){
 				appRate.preferences.useLanguage = commonService.selectedItem;
 				appRate.preferences.usesUntilPrompt=2;
 				appRate.preferences.simpleMode=true;
 				appRate.preferences.storeAppURL = {
 					//ios: '<my_app_id>',
 					android: 'https://play.google.com/store/apps/details?id=com.feedrate.in',
 					//blackberry: 'appworld://content/[App Id]/',
 					//windows8: 'ms-windows-store:Review?name=<the Package Family Name of the application>'
 				};

 				appRate.preferences.customLocale= {
 					title: "Please rate us to serve you better using %@?",
 					message: "It won’t take more than a minute and helps to improve our app. Thanks for your support!",
 					cancelButtonLabel: "No, Thanks",
 					laterButtonLabel: "Remind Me Later",
 					rateButtonLabel: "Rate It Now",
 					yesButtonLabel: "Yes!",
 					noButtonLabel: "Not really",
 					appRatePromptTitle: 'Do you like to rate %@',//'Do you like using %@',
 					feedbackPromptTitle: 'Mind giving us some feedback?',
 				},

 				appRate.preferences.callbacks={
 					// onRateDialogShow: function(callback) {
 						//   this.appRateShown=true;
 						//   alert("popup shown");
 						// },
 						onButtonClicked: function(buttonIndex){
 							//later =2 , never =1,  rate now=3 , yes=2 not really=1
 							//if(this.appRateShown){
 								commonService.setAppRatePopupSetting(buttonIndex);
 								//}              
 							}
 						}

 						if(commonService.checkAppRatePopupSetting()){
 							appRate.promptForRating(true);
 						}

 					}


 				}); 
 		commonService.backButtonAction(navCtrl);
 	}

 	ionViewDidLoad() {
 		this.getCompanyRatings();
 		this.getCompanyRatingCollectors();
 	}


 	public getCompanyRatings(){

 		this.commonService.showLoading();
 		this.commonService.getCompanyRatings().subscribe(success => {
 			this.commonService.dismisshowoading();
 			if (success && success.status=="success") {

 				this.ratingFactor=success.data.factorsData;
 				this.ratingStatistics=success.data.ratingStatistics;
 				if(success.data.ratingStatistics.lastRatingGiven=="0"){
 					this.ratingStatistics.lastRatedAt="N/A";
 				}else{
 					this.ratingStatistics.lastRatedAt=this.commonService.timeDifference(success.data.ratingStatistics.lastRatingGiven);
 				}
 				
 			} else {
 				this.commonService.showPopup("No Data", success.message);
 			}
 		},error=>{
 			this.commonService.dismisshowoading();
 		});
 	}


 	public filterRating(){
 		if(this.selectedDays!='all' || this.ratingTakenBy!="all"){
 			this.commonService.showLoading();
 			this.commonService.filterCompanyRatings(this.selectedDays, this.ratingTakenBy).subscribe(success => {
 				this.commonService.dismisshowoading();
 				if (success && success.status=="success") {

 					this.ratingFactor=success.data.factorsData;
 					this.ratingStatistics=success.data.ratingStatistics;
 					//this.ratingStatistics.lastRatedAt=this.commonService.timeDifference(success.data.ratingStatistics.lastRatingGiven);
 				} else {
 					this.commonService.showPopup("No Data", success.message);
 				}
 			},error=>{
 				this.commonService.dismisshowoading();
 				//this.commonService.dismisshowoading();


 			});

 		}else{
 			this.getCompanyRatings();

 		}

 	}


 	public getCompanyRatingCollectors(){

 		var loggedInUserData=this.commonService.getLoggedInUserData();
 		if(loggedInUserData && loggedInUserData.company.subscribedPlan){
 			if(loggedInUserData.isSuperAdmin=="1"){
 				this.showRatingTakenBy=true;
 				//this.commonService.showLoading();
		 		this.commonService.getCompanyRatingCollectors().subscribe(success => {
		 			//this.commonService.dismisshowoading();
		 			if (success && success.status=="success") {
		 				this.ratingCollectorList=success.data;
		 			} else {
		        	 // success=JSON.parse(success);
		        	 //this.commonService.showPopup("No Data", success.message);
		        	}
		        });
		 	}
 		}
 			
 	}



 	openPage(page) {
 		// close the menu when clicking a link from the menu
 		this.menu.close();
 		// navigate to the new page if it is not the current page
 		//this.nav.setRoot(page.component);
 	}

 	viewCommentsPage(){
 		this.navCtrl.setRoot('CommentPage');
 	}

 }



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts